// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueBus from 'vue-bus'
import axios from 'axios'
import VueAxios from 'vue-axios'

// 引入vant
import Vant from 'vant'
import 'vant/lib/index.css'

// 全屏滚动插件 用0.1版本，0.2版本适用vue3
import 'fullpage.js/dist/fullpage.min.css'
// import 'fullpage.js/dist/fullpage.extensions.min.js'
// import 'fullpage.js/vendors/scrolloverflow';
// import './fullpage.scrollHorizontally.limited.min.js'
import VueFullPage from 'vue-fullpage.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

// 引入适配
import 'amfe-flexible'

// 引入less
import less from 'less'

Vue.use(VueBus)
Vue.use(less)
Vue.use(VueFullPage)
Vue.use(Vant)
Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)


Vue.prototype.$rootUrl = process.env.API_ROOT //设置地址
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js